export const TRAVEL_BUDGET_CODES = [
    957290006,
    957290007
];

export const EQUIPMENT_BUDGET_CODES = [
    957290009
];

export const SERVIVES_BUDGET_CODES = [
    957290015,
    957290016,
];

export const OTHER_BUDGET_CODES = [
    957290017,
    957290018,
    957290019,
    957290020,
];

export const SALARY_BUDGET_CODES = [
    957290001,
    957290005,
];

export const SUPPLIES_MATERIALS_SERVICES_BUDGET_CODES = [
    957290012,
];

export const OVERHEAD_BUDGET_CODES = [
    957290021,
];
